import styled, { css } from 'styled-components';

import { elevation, elevationTransition } from 'ggApp/utils/mixins/elevation';


const Wrap = styled.div`
    height: 48px;
    padding: 0 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background: ${({ theme }) => theme.colors.ElementBackground};
    border-radius: 24px;
    color: ${({ theme }) => theme.colors.Foreground};
    ${elevation(1, false)};
    ${elevationTransition(false)};
    &:hover {
        ${elevation(3, false)};
        border: none;
    }
    &:focus {
        ${elevation(2, false)};
        border: none;
    }
`;

const Label = styled.span`
    margin: ${({ theme }) => `0 ${theme.spacers.S} 0 ${theme.spacers.M}`};
    color: ${({ color, theme, colorToken }) => color || theme.colors[colorToken] || theme.colors.Foreground};
    ${({ theme }) => css(theme.typography.SmallHeadline)}
`;

export { Wrap, Label };
